import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  isLoading: Subject<boolean> = this.loaderService.isLoading;
  url: string;
  showLoader: boolean = true;
  public serverPath: string = environment.commonImageApi + "logo/";
  public logoUrl: string = this.serverPath + "logoBG.png";
  public fallbackLogo: string = this.serverPath + "logo.png";
  public errorLogo: string = 'assets/images/error/logoerror1.png';

  constructor(
    private router: Router,
    private loaderService: LoaderService
  ) {}

  // color = 'primary';
  mode = 'indeterminate';

  ngOnInit(): void {
    this.url = this.router.url;

    if (this.router.url == '/category') {
      this.showLoader = false;
    }
  }

  onLogoError(event: any): void {
    if (event.target.src !== this.fallbackLogo) {
      event.target.src = this.fallbackLogo;
    } else {
      event.target.src = this.errorLogo;
    }
  }

}
